import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';

import DetailsHeader from '../OffersDetails/DetailsHeader/DetailsHeader'
import { truncateText } from '../../helpers/utils';
import Gallery from '../Gallery/Gallery';
import PickupZipcode from '../OffersDetails/PickupZipcode/PickupZipcode';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import VehicleDetailsGeneral from '../molecules/VehicleDetailsGeneral';
import DetailsDescription from '../OffersDetails/DetailsDescription/DetailsDescription';
import { styles } from '../AuctionForm/formStyles';
import CamperImage from '../../images/camper.png'

const CamperDetails = ({ details, t, isMobile, whichFolder, }) => {
  const createdAt = (() => {
    switch (whichFolder) {
      case 'browse':
        return get(details, 'published_at');
      case 'my_bets':
        return get(details, 'updated_at');
      case 'new_bets':
        return get(details, 'updated_at');
      case 'in_realization':
        return get(details, ['details', 'contact_details', 'updated_at']);
      default:
        return null;
    }
  });

  const photos = get(details, 'photos') || [];
  const classes = useStyles()
  if (!Object.keys(details).length) {
    return null
  }

  return (
    <div className={classes.detailsLeftColumn}>
      <div className={classes.row}>
        <DetailsHeader
          score={get(details, ['vehicle', 'score'])}
          details={[
            truncateText(get(details, ['vehicle', 'body_mark']), 7, 'right'),
            truncateText(get(details, ['vehicle', 'model']), 7, 'right'),
            get(details, ['vehicle', 'year']),
            get(details, 'hash_id'),
            createdAt()
          ]}
        />
      </div>
      <div>
        <img className={classes.image} src={CamperImage} />
      </div>
      <Gallery photos={photos} />
      <PickupZipcode
        translations={t('pickup_zipcode')}
        zipCode={get(details, 'zip_code')}
        pickUp={get(details, 'place')}
        countryCode={get(details, 'country_code')}
      />

      {!isMobile &&
        <VehicleDetailsGeneral
          fields={[
            { key: 'defects', value: details.vehicle.defects, positiveValues: [false], },
            { key: 'accident_free', value: details.vehicle.accident_free,  positiveValues: [true], },
            { key: 'rental', value: details.vehicle.rental, positiveValues: [false], },
            { key: 'service_booklet', value: details.vehicle.service_booklet, positiveValues: ['run'], }
          ]}
        />
      }

      <DetailsDescription
        fields={[
          { icon: 'defects_description', categoryName: t('details_description.defects_description'),
            description: get(details, ['vehicle', 'defects_description']), iconColor: styles.colors.red, },
          { icon: 'accessories_description', categoryName: t('details_description.accessories_description'),
            description: get(details, ['vehicle', 'accessories_description']), },
          get(details, 'comments')?.length
            ? { icon: 'comments', categoryName: t('details_description.comments'),
                description: get(details, 'comments'), }
            : null
        ].filter(Boolean)}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const details = get(state, ['offerDetails', 'data']);
  return {
    isMobile: get(state, ['layout', 'isMobile']),
    details,
  };
};

const useStyles = createUseStyles({
  detailsLeftColumn: {
    paddingLeft: '15px !important',
    paddingRight: '15px !important',
    width: '58.33333333%',
    float: 'left',
  },
  image: {
    maxWidth: '100%',
    padding: '25px',
  },
  row: {
    display: 'flex',
  },
  '@media(max-width: 900px)': {
    detailsLeftColumn: {
      width: '100%',
    },
  },
})

CamperDetails.propTypes = {
  whichFolder: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  details: PropTypes.shape({
    photos: PropTypes.arrayOf(PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      })),
    vehicle: PropTypes.shape({
      defects: PropTypes.bool,
      accident_free: PropTypes.bool,
      rental: PropTypes.bool,
      service_booklet: PropTypes.string,
    }),
  }).isRequired,
}

export default compose(
  withScopedTranslations('offer_details'),
  connect(mapStateToProps)
)(CamperDetails)
